import type { DirectedWizardStep } from '../directedSteps';

/** The sections of "How it was made", in page order (design l1). The price section holds the make too. */
export const MADE_SECTIONS: readonly DirectedWizardStep[] = ['cast', 'stories', 'style', 'script', 'price'];

/** The element id of the section of a step (`progress` scrolls to the price and make). Pure. */
export function madeSectionId(step: DirectedWizardStep): string {
  return `directed-made-${step === 'progress' ? 'price' : step}`;
}
